/**
 * posterarte-wishlist-page.js
 * POSTERARTE — Wishlist page renderer.
 *
 * Lee "pa-wishlist" (array de {id, handle}) de localStorage y pide cada tarjeta
 * YA RENDERIZADA a Liquid con la Section Rendering API:
 *
 *     GET /products/<handle>?section_id=posterarte-wishlist-card
 *
 * Hasta el 2026-08-15 este fichero construia la tarjeta a mano desde
 * /products/<handle>.js. Se cambio por dos motivos, en este orden:
 *
 *  1. Ese endpoint NO devuelve metafields, y la categoria del producto vive en
 *     uno (custom.categorias). Medido sobre los 157 productos activos: con lo
 *     que ve el JS se etiquetaba el 21% del catalogo; desde Liquid, el 49%.
 *  2. El marcado de la tarjeta estaba escrito DOS veces —aqui y en
 *     posterarte-collection-grid.liquid— y ya habian divergido: el orden de
 *     titulo y etiqueta no coincidia entre las dos.
 *
 * Quitar una tarjeta sigue actualizando localStorage y el contador de la
 * cabecera (.pa-wishlist-count).
 */
(function () {
  'use strict';

  var WISHLIST_KEY = 'pa-wishlist';

  /* ── Storage (same format/contract as posterarte.collection.js) ── */
  function getWishlist() {
    try {
      var raw = localStorage.getItem(WISHLIST_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      var map = new Map();
      if (Array.isArray(arr)) {
        arr.forEach(function (item) {
          if (typeof item === 'string') {
            map.set(item, { id: item, handle: '' });
          } else if (item && item.id != null) {
            map.set(String(item.id), { id: String(item.id), handle: item.handle || '' });
          }
        });
      }
      return map;
    } catch (_e) { return new Map(); }
  }
  function saveWishlist(map) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(Array.from(map.values()))); }
    catch (_e) { /* storage unavailable */ }
    // Con sesion, posterarte-favoritos.js sube la lista a la cuenta.
    try { if (window.paFavoritos) window.paFavoritos.cambio(); } catch (_e) { /* nada */ }
  }

  /* ── Header counter badge ── */
  function updateDawnCounter() {
    var count = getWishlist().size;
    document.querySelectorAll('.pa-wishlist-count').forEach(function (badge) {
      if (count > 0) { badge.textContent = count; badge.style.display = ''; }
      else { badge.textContent = '0'; badge.style.display = 'none'; }
    });
  }

  /* ── La tarjeta, pedida a Liquid ── */
  var CARD_SECTION = 'posterarte-wishlist-card';

  /* La Section Rendering API devuelve la seccion envuelta en su
     <div id="shopify-section-…">. Ese envoltorio NO puede entrar en la rejilla:
     .pa-col-grid coloca a sus hijos directos, y un div de por medio dejaria una
     sola columna. Se extrae el <article>. */
  function cardFromSectionHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('.pa-col-card');
  }

  function fetchCard(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=' + CARD_SECTION,
                 { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.text() : null; })
      .then(function (html) { return html ? cardFromSectionHtml(html) : null; })
      .catch(function () { return null; });
  }

  /* ── Init ── */
  function init() {
    var grid  = document.getElementById('pa-wishlist-grid');
    var empty = document.getElementById('pa-wishlist-empty');
    if (!grid) return;

    /* pintar() se llama al cargar y otra vez si la cuenta trae una lista
       distinta (evento 'pa:favoritos' de posterarte-favoritos.js). La vuelta
       lleva su numero para que una respuesta lenta de la primera no pinte
       encima de la segunda. */
    var vuelta = 0;
    function pintar() {
      var esta = ++vuelta;
      updateDawnCounter();
      grid.innerHTML = '';

      var wl = getWishlist();
      if (wl.size === 0) {
        if (empty) empty.hidden = false;
        return;
      }
      if (empty) empty.hidden = true;

      var items = Array.from(wl.values());
      Promise.all(items.map(function (item) {
        return item.handle ? fetchCard(item.handle) : Promise.resolve(null);
      })).then(function (cards) {
        if (esta !== vuelta) return;
        var rendered = 0;
        cards.forEach(function (card) {
          if (!card) return;
          grid.appendChild(card);
          rendered++;
        });
        if (rendered === 0 && empty) empty.hidden = false;
      });
    }
    pintar();
    document.addEventListener('pa:favoritos', pintar);

    // Remove from wishlist (event delegation)
    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('.pa-col-card__wishlist[data-product-id]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.dataset.productId;
      var map = getWishlist();
      map.delete(id);
      saveWishlist(map);
      updateDawnCounter();
      var card = btn.closest('.pa-col-card');
      if (card) card.remove();
      if (map.size === 0 && empty) empty.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
